export default __webpack_public_path__ + "static/media/bg3.dceef3d0.png";